/**
 * Swym Wishlist fix — hide the floating heart button when ANY overlay is open.
 *
 * The Swym app on this store uses the NEW Shopify App Extension UI:
 *   <div id="swym-storefront-extention-render-container">
 *     <swym-storefront-layout class="swym-storefront-layout-root-component">
 *       (Shadow DOM renders the floating heart button inside here)
 *     </swym-storefront-layout>
 *   </div>
 *
 * Since Shadow DOM prevents querySelectorAll from reaching inner elements,
 * we hide the HOST element itself.
 *
 * Detection: body.overflow-hidden (set by Dawn's search modal, cart drawer, menu drawer)
 */
(function () {
    'use strict';

    /* ---- selectors that cover BOTH old and new Swym UIs ---- */
    var SWYM_SELECTORS = [
        /* NEW Swym App Extension (storefront layout) */
        'swym-storefront-layout',
        '#swym-storefront-extention-render-container',
        '.swym-storefront-layout-root-component',

        /* OLD Swym plugin (fallback) */
        '#swym-plugin',
        '#swym-hosted-plugin',
        '.swym-wishlist-button-bar',
        '.swym-button-bar',
        '.swym-button.swym-add-to-wishlist-view-product',

        /* Collections wishlist button */
        '.swym-wishlist-collections-v2',
        '.swym-advanced-wishlist-collections-container'
    ].join(',');

    var hideInterval = null;
    var wasHidden = false;

    function hideSwym() {
        var els = document.querySelectorAll(SWYM_SELECTORS);
        for (var i = 0; i < els.length; i++) {
            els[i].style.setProperty('display', 'none', 'important');
            els[i].style.setProperty('visibility', 'hidden', 'important');
            els[i].style.setProperty('pointer-events', 'none', 'important');
        }
    }

    function showSwym() {
        var els = document.querySelectorAll(SWYM_SELECTORS);
        for (var i = 0; i < els.length; i++) {
            els[i].style.removeProperty('display');
            els[i].style.removeProperty('visibility');
            els[i].style.removeProperty('pointer-events');
        }
    }

    function checkState() {
        var overlayOpen = document.body.classList.contains('overflow-hidden');

        if (overlayOpen && !hideInterval) {
            /* Start continuous hiding — the Swym app may re-render */
            hideSwym();
            hideInterval = setInterval(hideSwym, 100);
            wasHidden = true;
        } else if (!overlayOpen && wasHidden) {
            /* Stop hiding and restore */
            if (hideInterval) {
                clearInterval(hideInterval);
                hideInterval = null;
            }
            showSwym();
            wasHidden = false;
        }
    }

    function init() {
        /* Watch body class changes */
        new MutationObserver(checkState).observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });

        /* Also enforce low z-index on Swym elements so theme overlays sit above */
        setInterval(function () {
            if (document.body.classList.contains('overflow-hidden')) {
                hideSwym();
            }
        }, 300);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /* Backup: also init after a delay for late-loading apps */
    setTimeout(function () {
        if (document.body) init();
    }, 3000);
})();
